var render, staticRenderFns
import script from "./table_config.vue?vue&type=script&lang=js"
export * from "./table_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff4844e4')) {
      api.createRecord('ff4844e4', component.options)
    } else {
      api.reload('ff4844e4', component.options)
    }
    
  }
}
component.options.__file = "found/views/config_center/view/list/form/table_config.vue"
export default component.exports